<template>
  <b-container class="container--max-lg">
    <nav class="c-progress-bar">
      <ol class="c-progress-bar__list list-unstyled mb-0">
        <li v-for="step in steps" v-bind:key="step.id" class="c-progress-bar__step" v-bind:class="{ 'is-active': isCurrentStep(step.id), 'is-disabled': step.disabled }">
          <b-link class="c-progress-bar__link" :to="step.link || ''" :disabled="step.disabled" v-bind:class="{ 'disabled-anchor': step.disabled }">
            <span class="c-progress-bar__step-indicator">
              <svg viewBox="0 0 38 37" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.16 0l14.978 7.214 3.7 16.208-10.366 12.999H10.846L.48 23.422l3.7-16.208z" fill="currentColor" fill-rule="evenodd" />
              </svg>
              <span>{{ step.id }}</span>
            </span>
            <span class="c-progress-bar__step-title">{{ step.text }}</span>
          </b-link>
        </li>
      </ol>
    </nav>
  </b-container>
</template>
<script>
export default {
  name: "WizardNavigation",
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    steps: {
      /**
       *  [{
       *    id: 1,
       *    text: "Certificate type",
       *    link: "/certificate/create/",
       *    disabled: false
       *  },...]
       */
      type: Array,
      required: true
    }
  },
  data: function() {
    return {};
  },
  methods: {
    isCurrentStep(page) {
      return page === this.currentStep;
    },
    isFutureStep(page) {
      return page > this.currentStep;
    }
  }
};
</script>
<style scoped>
a.disabled-anchor {
  pointer-events: none;
  cursor: default;
}
</style>
